import { useNavigation } from "@react-navigation/core";
import React, { useState } from "react";
import {
  TouchableOpacity,
  StatusBar,
  StyleSheet,
  Text,
  TextInput,
  View,
} from "react-native";
import { useDispatch } from "react-redux";
import { saveIdentity } from "../store/identitySlice";

const AddIdentityScreen = () => {
  const [nama, setNama] = useState("");
  const [ttl, setTtl] = useState("");
  const [activeGenderTab, setActiveGenderTab] = useState("Laki-Laki");
  const [alamat, setAlamat] = useState("");
  const [activeMarriageTab, setActiveMarriageTab] = useState("Kawin");
  const [kewarganegaraan, setKewarganegaraan] = useState("");
  const [activeEducationTab, setActiveEducationTab] = useState("SD");
  const [pendidikan, setPendidikan] = useState("");

  const navigation = useNavigation();
  const dispatch = useDispatch();

  const addIdentity = () => {
    dispatch(
      saveIdentity({
        nama: nama,
        ttl: ttl,
        gender: activeGenderTab,
        alamat: alamat,
        activeMarriageTab: activeMarriageTab,
        kewarganegaraan: kewarganegaraan,
        educationTab: activeEducationTab,
        pendidikan: pendidikan,
      })
    );

    {
      nama &&
        ttl &&
        activeGenderTab &&
        alamat &&
        activeMarriageTab &&
        kewarganegaraan &&
        activeEducationTab &&
        navigation.navigate("Home");
    }
  };

  return (
    <View style={styles.addIdentity}>
      <Text style={styles.addIdentityTitle}>Identitas Pribadi</Text>

      <View style={styles.addIdentityInput}>
        <Text style={styles.addIdentityInputText}>Nama Lengkap</Text>
        <TextInput
          autoCapitalize="none"
          autoCorrect={false}
          placeholder="Baskoro Aji"
          keyboardType="default"
          style={styles.addIdentityInputTextInput}
          onChangeText={(nama) => setNama(nama)}
          defaultValue={nama}
        />
      </View>

      <View style={styles.addIdentityInput}>
        <Text style={styles.addIdentityInputText}>Tanggal Lahir</Text>
        <TextInput
          autoCapitalize="none"
          autoCorrect={false}
          placeholder="DD/MM/YYYY"
          keyboardType="default"
          style={styles.addIdentityInputTextInput}
          onChangeText={(ttl) => setTtl(ttl)}
          defaultValue={ttl}
        />
      </View>

      <View style={styles.addIdentityInput}>
        <Text style={[styles.addIdentityInputText, { marginBottom: 10 }]}>
          Jenis Kelamin
        </Text>
        <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
          <GenderButton
            text="Laki-Laki"
            btnColor="black"
            textColor="white"
            activeTab={activeGenderTab}
            setActiveTab={setActiveGenderTab}
          />
          <GenderButton
            text="Perempuan"
            btnColor="white"
            textColor="black"
            activeTab={activeGenderTab}
            setActiveTab={setActiveGenderTab}
          />
        </View>
      </View>

      <View style={styles.addIdentityInput}>
        <Text style={styles.addIdentityInputText}>Alamat Lengkap</Text>
        <TextInput
          autoCapitalize="none"
          autoCorrect={false}
          placeholder="Arih Rahman Hakim No. 32, Surabaya"
          keyboardType="default"
          style={styles.addIdentityInputTextInput}
          onChangeText={(alamat) => setAlamat(alamat)}
          defaultValue={alamat}
        />
      </View>

      <View style={styles.addIdentityInput}>
        <Text style={[styles.addIdentityInputText, { marginBottom: 10 }]}>
          Status Perkawinan
        </Text>
        <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
          <MarriageButton
            text="Kawin"
            btnColor="black"
            textColor="white"
            activeTab={activeMarriageTab}
            setActiveTab={setActiveMarriageTab}
          />
          <MarriageButton
            text="Belum Kawin"
            btnColor="white"
            textColor="black"
            activeTab={activeMarriageTab}
            setActiveTab={setActiveMarriageTab}
          />
          <MarriageButton
            text="Cerai"
            btnColor="white"
            textColor="black"
            activeTab={activeMarriageTab}
            setActiveTab={setActiveMarriageTab}
          />
        </View>
      </View>

      <View style={styles.addIdentityInput}>
        <Text style={styles.addIdentityInputText}>Kewarganegaraan</Text>
        <TextInput
          autoCapitalize="none"
          autoCorrect={false}
          placeholder="WNI"
          keyboardType="default"
          style={styles.addIdentityInputTextInput}
          onChangeText={(kewarganegaraan) =>
            setKewarganegaraan(kewarganegaraan)
          }
          defaultValue={kewarganegaraan}
        />
      </View>

      <View style={styles.addIdentityInput}>
        <Text style={[styles.addIdentityInputText, { marginBottom: 10 }]}>
          Pendidikan Terakhir
        </Text>
        <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
          <EducationButton
            text="SD"
            btnColor="black"
            textColor="white"
            activeTab={activeEducationTab}
            setActiveTab={setActiveEducationTab}
          />
          <EducationButton
            text="SMP"
            btnColor="white"
            textColor="black"
            activeTab={activeEducationTab}
            setActiveTab={setActiveEducationTab}
          />
          <EducationButton
            text="SMA"
            btnColor="white"
            textColor="black"
            activeTab={activeEducationTab}
            setActiveTab={setActiveEducationTab}
          />
          <EducationButton
            text="S1"
            btnColor="white"
            textColor="black"
            activeTab={activeEducationTab}
            setActiveTab={setActiveEducationTab}
          />
          <EducationButton
            text="S2"
            btnColor="white"
            textColor="black"
            activeTab={activeEducationTab}
            setActiveTab={setActiveEducationTab}
          />
          <EducationButton
            text="Lain-lain"
            btnColor="white"
            textColor="black"
            activeTab={activeEducationTab}
            setActiveTab={setActiveEducationTab}
          />
        </View>
        {activeEducationTab === "Lain-lain" && (
          <TextInput
            autoCapitalize="none"
            autoCorrect={false}
            placeholder="Lain-lain"
            keyboardType="email-address"
            style={styles.addIdentityInputTextInput}
            onChangeText={(pendidikan) => setPendidikan(pendidikan)}
            defaultValue={pendidikan}
          />
        )}
      </View>

      <TouchableOpacity onPress={addIdentity}>
        <View style={styles.addIdentityButton}>
          <Text style={styles.addIdentityButtonText}>
            Simpan Identitas Pribadi
          </Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default AddIdentityScreen;

const GenderButton = (props: any) => (
  <TouchableOpacity
    style={{
      backgroundColor: props.activeTab === props.text ? "#FF2828" : "#F8F8F8",
      paddingVertical: 3,
      paddingHorizontal: 10,
      borderRadius: 30,
      height: 30,
      maxWidth: 150,
      alignItems: "center",
      justifyContent: "center",
      marginHorizontal: 2,
    }}
    onPress={() => props.setActiveTab(props.text)}
  >
    <Text
      style={{
        color: props.activeTab === props.text ? "#F8F8F8" : "black",
        fontSize: 16,
        fontWeight: "500",
      }}
    >
      {props.text}
    </Text>
  </TouchableOpacity>
);

const MarriageButton = (props: any) => (
  <TouchableOpacity
    style={{
      backgroundColor: props.activeTab === props.text ? "#FF2828" : "#F8F8F8",
      paddingVertical: 3,
      paddingHorizontal: 10,
      borderRadius: 30,
      height: 30,
      maxWidth: 150,
      alignItems: "center",
      justifyContent: "center",
      marginHorizontal: 2,
    }}
    onPress={() => props.setActiveTab(props.text)}
  >
    <Text
      style={{
        color: props.activeTab === props.text ? "#F8F8F8" : "black",
        fontSize: 16,
        fontWeight: "500",
      }}
    >
      {props.text}
    </Text>
  </TouchableOpacity>
);

const EducationButton = (props: any) => (
  <TouchableOpacity
    style={{
      backgroundColor: props.activeTab === props.text ? "#FF2828" : "#F8F8F8",
      paddingVertical: 3,
      paddingHorizontal: 10,
      borderRadius: 30,
      height: 30,
      maxWidth: 150,
      alignItems: "center",
      justifyContent: "center",
      marginHorizontal: 2,
    }}
    onPress={() => props.setActiveTab(props.text)}
  >
    <Text
      style={{
        color: props.activeTab === props.text ? "#F8F8F8" : "black",
        fontSize: 16,
        fontWeight: "500",
      }}
    >
      {props.text}
    </Text>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  addIdentity: {
    flex: 1,
    backgroundColor: "#F8F8F8",
    paddingTop: StatusBar.currentHeight,
    paddingHorizontal: "15%",
  },
  addIdentityTitle: {
    fontSize: 30,
    fontWeight: "500",
    marginTop: 50,
    marginBottom: 20,
  },
  addIdentityInput: {
    marginBottom: 20,
  },
  addIdentityInputText: {
    color: "#FF2828",
    fontSize: 16,
    fontWeight: "500",
  },
  addIdentityInputTextInput: {
    fontSize: 16,
    fontWeight: "500",
    placeholderTextColor: "#bbb",
    borderBottomWidth: 1,
    borderBottomColor: "#bbb",
    marginTop: 10,
  },
  addIdentityButton: {
    backgroundColor: "#FF2828",
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 5,
    marginTop: 20,
  },
  addIdentityButtonText: {
    color: "#F8F8F8",
    fontWeight: "500",
    fontSize: 16,
  },
});
